import { render, staticRenderFns } from "./YKUseCaseDetail.vue?vue&type=template&id=042a6570&scoped=true&"
import script from "./YKUseCaseDetail.vue?vue&type=script&lang=js&"
export * from "./YKUseCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./YKUseCaseDetail.vue?vue&type=style&index=0&id=042a6570&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042a6570",
  null
  
)

export default component.exports